import { render } from "./Amount.vue?vue&type=template&id=058f88a8&scoped=true"
import script from "./Amount.vue?vue&type=script&lang=js"
export * from "./Amount.vue?vue&type=script&lang=js"

import "./Amount.vue?vue&type=style&index=0&id=058f88a8&lang=scss&scoped=true"

import exportComponent from "D:\\project\\cloud-api-web-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-058f88a8"]])

export default __exports__